import moment from 'moment';
import {
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
} from '@fortawesome/free-solid-svg-icons';

export const DEFAULT_PERIOD = {
  startDate: moment().subtract(30, 'days').toDate(),
  endDate: moment().toDate(),
  label: 'Last 30 Days',
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';
export const DISPLAY_DATE_RANGE_FORMAT = 'MMM DD';

export const TREND_COLORS = {
  up: '#52c41a',
  down: '#ff4d4f',
  neutral: '#8c8c8c',
} as const;

export const TREND_BADGE_COLORS = {
  up: 'success',
  down: 'error',
  neutral: 'default',
} as const;

export const TREND_LABELS = {
  up: 'Growing',
  down: 'Declining',
  neutral: 'Baseline',
} as const;

export const TREND_ICONS = {
  up: faArrowTrendUp,
  down: faArrowTrendDown,
  neutral: faMinus,
} as const;

export const CARD_BORDER_COLORS = {
  primary: '#1890ff',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
} as const;
